import { render, staticRenderFns } from "./active-index.vue?vue&type=template&id=06fa8ba5"
import script from "./active-index.vue?vue&type=script&lang=js"
export * from "./active-index.vue?vue&type=script&lang=js"
import style0 from "./active-index.vue?vue&type=style&index=0&id=06fa8ba5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports